import React from "react";
import { Link } from "gatsby";
import { Wrapper } from "./FooterNavigation.styles"

const FooterNavigation = ({ menu }) => {
    return(
        <Wrapper>
            <ul>
                {menu.map(mainItem => 
                    !mainItem.parentId
                        ? (
                            <li key={mainItem.id}>
                                {
                                    mainItem.target !== null
                                        ? (
                                            <a href={mainItem.url} target={mainItem.target} className={mainItem.cssClasses.join(' ')}>
                                                {mainItem.label}
                                                {mainItem.childItems.nodes.length !== 0 && <div>&#8964;</div>}
                                            </a>
                                          )

                                        : (
                                            <Link to={mainItem.url}>
                                                {mainItem.label}
                                                {mainItem.childItems.nodes.length !== 0 && <div>&#8964;</div>}
                                            </Link>
                                          )
                                }

                                {mainItem.childItems.nodes.length !== 0 ? (
                                    <ul>
                                        {mainItem.childItems.nodes.map(childItem => (
                                            <li key={childItem.id}>
                                                <Link to={childItem.url}>
                                                    {childItem.label}
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                ) : null }
                            </li>
                        )
                        : null
                    )
                }
            </ul>
        </Wrapper>
    )
}

export default FooterNavigation;